import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    newsBanner: {
        position: 'relative',
        margin: theme.spacing(4),
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(3), // Add spacing between multiple news items
        borderRadius: theme.spacing(2),
        background: `linear-gradient(135deg, rgba(27, 21, 74, 0.05) 0%, rgba(27, 21, 74, 0.1) 100%)`,
        color: theme.palette.text.primary,
        overflow: 'hidden',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: '0 4px 16px rgba(27, 21, 74, 0.08)',
        width: '64rem', // Match the width of two cards (30rem each + spacing)
        border: `1px solid rgba(27, 21, 74, 0.1)`,
        '&:hover': {
            boxShadow: '0 8px 24px rgba(27, 21, 74, 0.12)',
            transform: 'translateY(-1px)',
        },
        '&:last-child': {
            marginBottom: theme.spacing(6), // Extra bottom margin for the last news item
        },
    },
    newsHeader: {
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    newsTitle: {
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: '1.3rem',
        marginBottom: theme.spacing(1),
    },
    newsDescription: {
        color: theme.palette.text.secondary,
        fontSize: '1rem',
        lineHeight: 1.6,
    },
    expandButton: {
        minWidth: 'auto',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        color: '#ffffff',
        borderRadius: '50%',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            transform: 'scale(1.05)',
        },
    },
    expandIcon: {
        transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        fontSize: '1.2rem',
    },
    expandIconRotated: {
        transform: 'rotate(180deg)',
    },
    expandedContent: {
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        overflow: 'hidden',
    },
    expandedContentInner: {
        padding: theme.spacing(0, 3, 3),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
        alignItems: 'center', // Center the image
    },
    newsImage: {
        maxWidth: '100%',
        maxHeight: 250,
        height: 'auto',
        width: 'auto',
        borderRadius: theme.spacing(1),
        objectFit: 'contain',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        marginBottom: theme.spacing(2),
        display: 'block',
    },
    newsContent: {
        flex: 1,
        color: theme.palette.text.primary,
        '& h3, & h4': {
            color: theme.palette.primary.main,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        '& p': {
            marginBottom: theme.spacing(2),
            lineHeight: 1.7,
        },
        '& a': {
            color: theme.palette.secondary.main,
            textDecoration: 'none',
            fontWeight: 500,
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        '& strong': {
            fontWeight: 600,
            color: theme.palette.primary.main,
        },
        '& table': {
            width: '100%',
            marginTop: theme.spacing(2),
            borderCollapse: 'collapse',
            backgroundColor: 'rgba(27, 21, 74, 0.05)',
            borderRadius: theme.spacing(1),
            overflow: 'hidden',
        },
        '& td': {
            padding: theme.spacing(1.5),
            borderBottom: '1px solid rgba(27, 21, 74, 0.1)',
            '&:last-child': {
                borderBottom: 'none',
            },
        },
        '& ul, & ol': {
            paddingLeft: theme.spacing(3),
            '& li': {
                marginBottom: theme.spacing(0.5),
            },
        },
    },
    newsLabel: {
        position: 'absolute',
        top: theme.spacing(2),
        left: theme.spacing(2),
        display: 'inline-block',
        padding: theme.spacing(0.5, 1.5),
        backgroundColor: theme.palette.tertiary.main,
        color: '#ffffff',
        borderRadius: theme.spacing(3),
        fontSize: '0.875rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        zIndex: 1,
    },
}));
